/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ props: NonNullable<unknown>, high: NonNullable<unknown> }} Addr_Wiz_SummaryInputs */

const cs_addr_wiz_summary = /** @type {(inputs: Addr_Wiz_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.props} nemovitostí s neúplnou adresou · ${i?.high} jistých návrhů`)
};

const en_addr_wiz_summary = /** @type {(inputs: Addr_Wiz_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.props} properties with incomplete addresses · ${i?.high} high-confidence suggestions`)
};

/**
* | output |
* | --- |
* | "{props} properties with incomplete addresses · {high} high-confidence suggestions" |
*
* @param {Addr_Wiz_SummaryInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const addr_wiz_summary = /** @type {((inputs: Addr_Wiz_SummaryInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Addr_Wiz_SummaryInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_addr_wiz_summary(inputs)
	return cs_addr_wiz_summary(inputs)
});